/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum KodowanieTyp {
  Base64 = 'BASE_64',
  Uri = 'URI',
  Xml = 'XML'
}
